<template>
  <div class="wrapper">
    <div class="page-header header-filter header-xs" :style="headerStyle">
    </div>
    <div class="section">
      <div class="container">
        <div class="main main-raised">
          <div class="close-button">
            <a href="/products">
              <img :src="closeButtonImage" />
            </a>
          </div>
          <div class="md-layout">
            <div class="md-layout-item md-size-50 md-small-size-100" v-if="images">
              <ProductZoomer :base-images="images" :base-zoomer-options="zoomerOptions" />
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <h2 class="title mb-1">{{ product.name }}</h2>
              <!-- <h3 class="main-price mb-0">
                ${{ product.price }}/{{ labelForProductUnit(product.units) }}
              </h3> -->
              <div class="ml-auto mb-1" :class="product.status">
                {{ labelForProductStatus(product.status) }}
              </div>
              <p style="font-style: italic">
                {{ product.minimumPurchase }}
              </p>
              <strong v-if="product.description">Product Description</strong>
              <p>
                {{ product.description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from '@/plugins/basicMixins';
import labelForProductStatus from '@/mixins/labelForProductStatus';
import labelForProductUnit from '@/mixins/labelForProductUnit';
import { Query } from '@/graphql';
import apollo from '@/services/apollo-graphql';

export default {
  mixins: [Mixins.HeaderImage, labelForProductStatus, labelForProductUnit],
  bodyClass: 'product-page',
  async created() {
    const response = await apollo.query({
      query: Query.getProduct,
      variables: { id: this.$route.params.pathMatch },
    });
    this.product = response.data.product;
  },
  data() {
    return {
      product: {},
      images: null,
      closeButtonImage: require('@/assets/img/icons8-close-50.png'),
      image: require('@/assets/img/products-bg.png'),
      zoomerOptions: {
        pane: 'container-round',
        hoverDelay: 300,
        namespace: 'inline-container',
        move_by_click: true,
        scroll_items: 4,
      },
    };
  },
  watch: {
    product() {
      if (this.product.photos && this.product.photos.length) {
        this.images = {
          normal_size: this.product.photos.map(photo => ({ id: photo.url, url: photo.url })),
        };
      } else {
        this.images = {
          normal_size: [{
            id: 1,
            url: require('@/assets/img/product-placeholder.png'),
          }],
        };
      }
    },
  },
};
</script>
<style lang="scss">
.inline-container-zoomer-box {
  .preview-box {
    text-align: center;
    margin-bottom: 5vh;
    margin-top: 2vh;

    img {
      max-width: 60%;
    }
  }

  .control-box {
    margin-bottom: 30px;
  }

  .thumb-list img {
    padding: 18px 8px;
    border: 1px solid transparent;
    opacity: 0.8;
    transition: all 0.15s ease;

    &:hover {
      opacity: 1;
      border-color: #ddd;
    }
  }

  .responsive-image {
    max-width: 80%;
    border-radius: 3px;

    &.choosed-thumb {
      box-shadow: none !important;
      border-color: #ddd;
    }
  }

  .control {
    font-size: 14px;

    path {
      fill: #9fa4ab;
    }
  }
}
</style>
